<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import BasicTextarea from '~/components/form-elements/BasicTextarea.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'

const model = defineModel<boolean>()

const messages = {
  failedToUpdateThisWeekDiscounts: 'Не удалось обновить скидки этой недели.',
  thisWeekDiscountsAreUpdated: 'Скидки этой недели обновлены.'
}

const { $apiHelper, $toast } = useNuxtApp()

const form = ref<any>({ payload: null })
const isSending = ref(false)

function close (): void {
  model.value = false
}

async function sendPayload (): Promise<void> {
  isSending.value = true

  const { failedToUpdateThisWeekDiscounts, thisWeekDiscountsAreUpdated } = messages

  try {
    await $apiHelper.scripts.updateThisWeekDiscounts(form.value.payload)

    $toast.success(thisWeekDiscountsAreUpdated)
  } catch (error) {
    console.error(error)

    $toast.error(failedToUpdateThisWeekDiscounts)
  }

  isSending.value = false
}
</script>

<template>
  <CustomModalWindow v-model="model" size="large">
    <template #title>
      Обновление скидок этой недели
    </template>

    <Notification class="mb-6" is-small status="info">
      Вставьте ссылки на&nbsp;страницы товаров (по&nbsp;одной в&nbsp;каждой строке). Неправильные ссылки будут проигнорированы.
    </Notification>

    <BasicTextarea v-model="form.payload" class="mb-6" label-text="Ссылки на товары" :max-length="65536" />

    <BasicButton color="green" :is-loading="isSending" title="Отправить" @click="sendPayload" />

    <template #action>
      <a href="#" @click.prevent="close">Закрыть</a>
    </template>
  </CustomModalWindow>
</template>
